import { Button } from '@nautilusbio/nb-design-system/Button';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Tooltip } from '@nautilusbio/nb-design-system/Tooltip';
import { useCopyToClipboard } from '@nautilusbio/nb-design-system/useCopyToClipboard';
import { useTimeout } from '@nautilusbio/nb-design-system/useTimeout';
import { Check, Copy } from 'lucide-react';
import React, { FC, useState } from 'react';

const hoverOptions = { delay: 2000 };
const sharedIconProps = {
  size: 14,
};

interface CopyTextProps {
  id: string;
  value?: string;
}

const CopyText: FC<CopyTextProps> = ({ id, value }) => {
  const { copy } = useCopyToClipboard();
  const { set: scheduleReset } = useTimeout();
  const [hasCopied, setHasCopied] = useState(false);
  const dataTestId = `copy-btn-${id}`;

  const handleCopy = () => {
    if (value) {
      copy(value);
      setHasCopied(true);
      scheduleReset(() => setHasCopied(false), 2000);
    }
  };

  return (
    <Stack alignItems="center" gap={4} justifyContent="start" orientation="horizontal">
      {value ?? ''}
      {!!value && (
        <Tooltip
          content={hasCopied ? 'Copied!' : 'Click here to copy.'}
          hoverOptions={hoverOptions}
          placement="right-start"
          trigger={
            <Button
              aria-label={hasCopied ? 'Copied!' : 'Copy to clipboard'}
              data-testid={dataTestId}
              onPress={handleCopy}
              size="sm"
              visual={hasCopied ? 'success' : 'primary'}
            >
              {hasCopied ? <Check {...sharedIconProps} /> : <Copy {...sharedIconProps} />}
            </Button>
          }
        />
      )}
    </Stack>
  );
};

export default CopyText;
